/**
 * created by zhouzt on 2020-03-26
 *
 * description: 发票模块接口地址
 *
 */

const config = require('libs/config.js')

const invoice = {
	// 获取发票信息
	getInvioce: config.MS_MB_PATH + '/v1/ct/mbTaxTicketMg/mbTaxTickets',
	// 设置默认发票信息
	setDefaultInvoice: (pkid, timemd5, ticketCode) => config.MS_MB_PATH + `/v1/ct/mbTaxTicketMg/setDefault/1/${pkid}/${timemd5}/${ticketCode}/0/1`,
	// 新增发票
	addInvoice: config.MS_MB_PATH + '/v1/ct/mbTaxTicketMg/mbTaxTicket/0',
	// 删除发票
	deleteInvoice: pkid => config.MS_MB_PATH + `/v1/ct/mbTaxTicketMg/mbTaxTicket/${pkid}`,
	// 修改发票
	editInvoice: pkid => config.MS_MB_PATH + `/v1/ct/mbTaxTicketMg/mbTaxTicket/${pkid}`,

	// 获取地址信息
	getAddress: config.MS_MB_PATH + '/v1/ct/mbPostalAddressMg/mbPostalAddresss',
	// 获取地区下拉数据
	getArea: config.MS_ADD_PATH + '/v1/bsDqManage/bsDqs',
	// 新增地址
	addAddress: config.MS_MB_PATH + '/v1/ct/mbPostalAddressMg/mbPostalAddress/0',
	// 设置默认地址
	setDefaultAddress: (pkid, timemd5) => config.MS_MB_PATH + `/v1/ct/mbPostalAddressMg/setDefault/1/${pkid}/${timemd5}/0/1`,
	// 修改地址
	editAddress: pkid => config.MS_MB_PATH + `/v1/ct/mbPostalAddressMg/mbPostalAddress/${pkid}`,
	// 删除地址
	deleteAddress: pkid => config.MS_MB_PATH + `/v1/ct/mbPostalAddressMg/mbPostalAddress/${pkid}`
}

export default invoice



// WEBPACK FOOTER //
// ./src/api/invoice/index.js